module.exports = __webpack_public_path__ + "static/media/1_armies.88fdea23.png";